import React, { ChangeEvent, useState } from 'react'
import Button from 'components/Button'
import InputUpload from 'components/InputUpload'
import { useTranslation } from 'react-i18next'
import * as XLSX from 'xlsx'
import { FileDataProps } from 'containers/Onboarding'
import {
  BRANCH_HEADER,
  BRANCH_SHEET_NAME,
  COMPANY_HEADER,
  COMPANY_SHEET_NAME,
  PRODUCT_HEADER,
  PRODUCT_SHEET_NAME,
  SKU_HEADER,
  SKU_SHEET_NAME,
  TEMPLATES,
} from '../constants'

interface props {
  setSteps: () => void
  onClose: () => void
  setDataSource: (data: [][] | []) => void
  setFileData?: (e: FileDataProps) => void
  type: string
}

export const UploadExcel = (props: props): JSX.Element => {
  const { setSteps, onClose, setDataSource, setFileData, type } = props
  const { t } = useTranslation(['common', 'onboarding'])
  const [fileSize, setFileSize] = useState<number>(0)
  const [isType, setIsType] = useState<boolean>(false)
  const [isHeader, setIsHeader] = useState<boolean>(false)
  const base = 'con-modal-upload-excel'

  const convertToMb = fileSize * 0.000001
  const checkFileSize = convertToMb > 2

  const handleFile = (e: ChangeEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement
    const files = target.files as unknown as File[]
    if (files && files[0]) {
      setFileData &&
        setFileData({ name: files[0].name as string, size: files[0].size })

      setFileSize(files[0].size)
      const reader = new FileReader()

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      reader.onload = (e: any) => {
        const bstr = e.target.result
        const wb = XLSX.read(bstr, { type: 'binary' })
        const wsIndex = wb.SheetNames.map(
          (sheetName) => sheetName === filterSheetName(),
        )
        const wsName = wb.SheetNames[wsIndex.indexOf(true)]
        const ws = wb.Sheets[wsName]
        const data: [][] = XLSX.utils.sheet_to_json(ws, { header: 1 })
        const headerConstant = getHeaderIndex(data)
        const headerType = filterHeaderName()
        const isHeader = validateExcelHeader(headerConstant, headerType)

        setIsType(data.length === 0)
        setIsHeader(isHeader)
        setDataSource(data)
      }

      reader.readAsBinaryString(files[0])
    }
  }

  const validateExcelHeader = (
    header: [],
    headerType: string[] | undefined,
  ): boolean => {
    if (
      JSON.stringify(header?.filter((element) => element)) ===
      JSON.stringify(headerType)
    ) {
      return false
    } else {
      return true
    }
  }

  const filterSheetName = () => {
    switch (type) {
      case 'company':
        return COMPANY_SHEET_NAME
      case 'branch':
        return BRANCH_SHEET_NAME
      case 'product':
        return PRODUCT_SHEET_NAME
      case 'sku':
        return SKU_SHEET_NAME
    }
  }

  const getHeaderIndex = (array: [][]) => {
    return array[TEMPLATES.columnHeaderIndex]
  }

  const filterHeaderName = () => {
    switch (type) {
      case 'company':
        return COMPANY_HEADER
      case 'branch':
        return BRANCH_HEADER
      case 'product':
        return PRODUCT_HEADER
      case 'sku':
        return SKU_HEADER
    }
  }

  return (
    <div className={`${base}`}>
      <h1 className={`${base}__title`}>
        {t('common:title.select.upload.file')}
      </h1>
      <span className={`${base}__description`}>
        {t('common:description.upload.template')}
      </span>
      <InputUpload
        onChange={(e) => {
          handleFile(e)
        }}
      />
      <div className={`${base}__text-alert`}>
        {checkFileSize && t('onboarding:text.alert.filesize')}
        {!checkFileSize &&
          (isType || isHeader) &&
          t('onboarding:text.alert.template')}
      </div>
      <div className={`${base}__button-group`}>
        <Button variants='secondary' onClick={onClose}>
          {t('common:cancel.button')}
        </Button>
        <Button onClick={setSteps}>{t('common:next.button')}</Button>
      </div>
    </div>
  )
}
